/**
 * The ids on a loop of rules (Tarjan's strongly connected components): every
 * id in a component of more than one can reach itself through the others.
 */
export default function findIdsOnLoops(ids, watchedIdsOf) {
  let nextIndex = 0;
  const indexOf = new Map();
  const lowOf = new Map();
  const stack = [];
  const onStack = new Set();
  const looped = new Set();

  const visit = id => {
    indexOf.set(id, nextIndex);
    lowOf.set(id, nextIndex);
    nextIndex += 1;
    stack.push(id);
    onStack.add(id);

    for (const watchedId of watchedIdsOf(id)) {
      if (!indexOf.has(watchedId)) {
        visit(watchedId);
        lowOf.set(id, Math.min(lowOf.get(id), lowOf.get(watchedId)));
      } else if (onStack.has(watchedId)) {
        lowOf.set(id, Math.min(lowOf.get(id), indexOf.get(watchedId)));
      }
    }

    if (lowOf.get(id) !== indexOf.get(id)) return;

    const component = [];
    let member;
    do {
      member = stack.pop();
      onStack.delete(member);
      component.push(member);
    } while (member !== id);
    if (component.length > 1) component.forEach(loopedId => looped.add(loopedId));
  };

  ids.forEach(id => {
    if (!indexOf.has(id)) visit(id);
  });

  return looped;
}
